export default __webpack_public_path__ + "static/media/1_5_hl.73dd2252.png";